module.exports = __webpack_public_path__ + "static/img/fresh-news.c0d71d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main-view/fresh-news.png
// module id = fDDk
// module chunks = 1